import React, { useEffect, useState } from 'react'
import ClassCardData from './ClassCardData'
import { useQuery } from '../../../utils/util'
import ClassCardAnalytics from './ClassCardAnalytics'
import { getClassAnalyticsInfo } from '../../../server/server'

function ClassCardWidget({ selectedClass, setSelectedClass }) {
    const [studentInfoOpen, setStudentInfoOpen] = useState(false)

    const [loading, setLoading] = useState(false)
    const query = useQuery()
    const classId = query.get('id')

    useEffect(() => {
        loadClass(classId)
    }, [classId])

    const loadClass = async (classId) => {
        const resp = await getClassAnalyticsInfo(classId)
        if (resp.status === 200) {
            setSelectedClass(resp.data)
            setLoading(false)
        }
    }

    return (
        <div className="min-w-[408px] max-w-[408px] h-fit bg-white rounded-[24px] ">
            <ClassCardData loading={loading} selectedClass={selectedClass} />
            <ClassCardAnalytics classId={classId} />
        </div>
    )
}

export default ClassCardWidget
